module.exports = __webpack_public_path__ + "static/media/condicoes_climaticas.6aabd98c.png";